import _mode from "./mode";
import _utils from "./utils";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
const Mode = _mode;
const Utils = _utils;
function KanjiData(data) {
  (this || _global).mode = Mode.KANJI;
  (this || _global).data = data;
}
KanjiData.getBitsLength = function getBitsLength(length) {
  return length * 13;
};
KanjiData.prototype.getLength = function getLength() {
  return (this || _global).data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength() {
  return KanjiData.getBitsLength((this || _global).data.length);
};
KanjiData.prototype.write = function (bitBuffer) {
  let i;

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < (this || _global).data.length; i++) {
    let value = Utils.toSJIS((this || _global).data[i]);

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 33088 && value <= 40956) {
      // Subtract 0x8140 from Shift JIS value
      value -= 33088;

      // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 57408 && value <= 60351) {
      // Subtract 0xC140 from Shift JIS value
      value -= 49472;
    } else {
      throw new Error("Invalid SJIS character: " + (this || _global).data[i] + "\n" + "Make sure your charset is UTF-8");
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (value >>> 8 & 255) * 192 + (value & 255);

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13);
  }
};
exports = KanjiData;
export default exports;